import { Exception } from 'src/app/core/logic/exception';

export class EncouragementNotFoundException extends Exception<never> {
  constructor() {
    super('Encouragement non trouvé');
  }
}
